import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "linear-gradient(135deg, #1167ff 0%, #08265f 100%)"};
  color: ${(p) => (p.color ? "#08265f" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid rgba(17, 103, 255, 0.2);
  border-radius: 8px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  min-width: 150px;
  max-width: 210px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgba(17, 103, 255, 0.2);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid #0f5be2;
    background: #0f5be2;
    transform: translateY(-1px);
  }
`;
